export const STATUS_OPTIONS = [
    {
        label: "Active",
        value: "active"
    },
    {
        label: "Disabled",
        value: "disabled"
    }
];